;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { cn } from '@qogita/ui/utils/cn'
import { cva } from 'class-variance-authority'
import clsx from 'clsx'

type LoadingDotsProps = {
  className?: string
  variant?: 'DEFAULT' | 'INLINE'
  rebranded?: boolean
}

const loadingDotsStyles = cva(
  cn(
    'animation-delay-100 m-1 size-1 animate-ping rounded-full motion-reduce:animate-none',
  ),
  {
    variants: {
      rebranded: {
        true: 'bg-gray-900',
        false: 'bg-primary-700',
      },
    },
  },
)

export const LoadingDots = ({
  className,
  variant = 'DEFAULT',
  rebranded,
}: LoadingDotsProps) => {
  return (
    <div
      className={clsx(
        'flex flex-row',
        {
          'items-center justify-center': variant === 'DEFAULT',
        },
        className,
      )}
    >
      <div className={loadingDotsStyles({ rebranded })} />
      <div className={loadingDotsStyles({ rebranded })} />
      <div className={loadingDotsStyles({ rebranded })} />
    </div>
  )
}
